function HelloWorld() {
  return (
    <div className="hello-world">
      <header className="hello-world__header">
        <h1 className="hello-world__title">Szybkie Fiszki 🚀</h1>
        <p className="hello-world__subtitle">
          Minimalna, skoncentrowana aplikacja do walidacji hipotezy
        </p>
      </header>

      <main className="hello-world__content">
        <section className="hello-world__section">
          <h2>Witaj w projekcie MVP!</h2>
          <p>
            Ten projekt to aplikacja webowa do szybkiego tworzenia fiszek
            edukacyjnych przez wklejenie tekstu w formacie{' '}
            <code>Pytanie::Odpowiedź</code>.
          </p>
        </section>

        <section className="hello-world__section">
          <h3>Stos technologiczny:</h3>
          <ul className="hello-world__list">
            <li>React 19 (functional components)</li>
            <li>Vite 5 (dev server & build)</li>
            <li>JavaScript ES2023+</li>
            <li>Supabase (PostgreSQL + Auth + RLS)</li>
            <li>Vitest (unit testing)</li>
            <li>Pure CSS (single global file)</li>
          </ul>
        </section>

        <section className="hello-world__section">
          <h3>Status projektu:</h3>
          <p className="hello-world__status">
            ✅ Struktura projektu utworzona
            <br />
            ✅ Vite + React skonfigurowane
            <br />
            ✅ Linting i formatowanie działa
            <br />
            🚧 Następny krok: implementacja komponentów UI
          </p>
        </section>
      </main>

      <footer className="hello-world__footer">
        <p>Projekt dla kursu 10xDevs</p>
      </footer>
    </div>
  )
}

export default HelloWorld
